<script>
import { defineComponent, reactive } from '@vue/composition-api'
import { ServiceProxy as ObsFileServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
const ofsp = new ObsFileServiceProxy()

export default defineComponent({
  props: ['value'],
  model: {
    prop: 'value',
    event: 'change',
  },
  setup(props, { root, emit }) {
    const file = reactive({
      list: [],
      obsList: [],
    })

    function  beforeUpload(f) {
      if (!f.type.includes('image')) {
        root.$message.error(root.$t('image_type_tip'))
        return false
      }
      if (f.size > 2 * 1024 * 1024) {
        root.$message.error(root.$t('image_size_tip'))
        return false
      }

      // const res = await (await ofsp.putFileUsingPOST({fileName:f.name, data:f})).data
      // const ossfile = await (await ofsp.statFileUsingGET(res.name)).data

      // file.list.push(f)

      // file.obsList.push({
      //   contentType: ossfile.contentType, 
      //   objectKey: ossfile.name,
      //   originalFilename: f.name,        
      // })
      // emit('change', file.obsList)

       ofsp.putFileUsingPOST({ fileName:f.name, data:f }).then(res=>{
         ofsp.statFileUsingGET(res.data.name).then(resOss=>{
            const ossfile = resOss.data
            file.list.push(f)

            file.obsList.push({
              contentType: ossfile.contentType, 
              objectKey: ossfile.name,
              originalFilename: f.name,        
            })
            emit('change', file.obsList)
         })
       })

      return false
    }

    function handleRemove(f) {
      const index = file.list.indexOf(f)
      ofsp.delete(file.obsList[index].objectKey).then(() => {
        file.list.splice(index, 1)
        file.obsList.splice(index, 1)
        emit('change', file.obsList)
      })
    }

    return {
      file,
      beforeUpload,
      handleRemove,
    }
  },
})
</script>

<template>
  <div>
    <a-upload multiple :fileList="file.list" :remove="handleRemove" :beforeUpload="beforeUpload">
      <a-button>
        <a-icon type="upload" />
        {{ $t('page_dform_click_upload') }}
      </a-button>
    </a-upload>
  </div>
</template>
